export const convertScheduleToClientTimezone = ({
  date,
  start,
  end,
  isDate,
  isHour,
}) => {
  const BASE_TZ_OFFSET = "+07:00"; // server timezone
  const SERVER_UTC_OFFSET = 7; // numeric offset for UTC+7

  // detect client timezone (auto or forced)
  const clientTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // get client offset (in hours)
  const clientOffset = -new Date().getTimezoneOffset() / 60;

  // if client UTC == server UTC → return empty string
  if (clientOffset === SERVER_UTC_OFFSET) {
    return "";
  }

  // create Date objects in UTC+7
  const startDateUTC7 = new Date(`${date}T${start}:00${BASE_TZ_OFFSET}`);
  const endDateUTC7 = new Date(`${date}T${end}:00${BASE_TZ_OFFSET}`);

  // convert into client timezone
  const startLocal = new Date(
    startDateUTC7.toLocaleString("en-US", { timeZone: clientTZ })
  );
  const endLocal = new Date(
    endDateUTC7.toLocaleString("en-US", { timeZone: clientTZ })
  );

  // client UTC label
  const clientUTC = `UTC${
    clientOffset >= 0 ? "+" + clientOffset : clientOffset
  }`;

  // helpers
  const formatTime = (d) =>
    d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

  const formatDate = (d) =>
    d.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  if (isDate && isHour) {
    return `${formatTime(startLocal)} - ${formatTime(endLocal)} on ${formatDate(
      startLocal
    )} (${clientUTC})`;
  } else {
    if (isDate) {
      return `${formatDate(startLocal)} (${clientUTC})`;
    }
    if (isHour) {
      return `${formatTime(startLocal)} - ${formatTime(
        endLocal
      )} (${clientUTC})`;
    }
  }
};
